import React from 'react';
import { carouselHeader, combineCarouselClasses } from './carousel.styles';
import type { CarouselHeaderProps } from './types';

/**
 * CarouselHeader - Header container for carousel title and controls
 *
 * Provides a flex container that positions title on the left and controls on the right.
 * Typically used in the compound API for more advanced carousel layouts.
 *
 * @example
 * ```tsx
 * <Carousel.Header>
 *   <Carousel.Title level={3}>Featured Properties</Carousel.Title>
 *   <Carousel.Controls />
 * </Carousel.Header>
 * ```
 */
export const CarouselHeader = React.forwardRef<HTMLDivElement, CarouselHeaderProps>(
  ({ children, className, ...restProps }, ref) => {
    const combinedClassName = combineCarouselClasses(carouselHeader, className);

    return (
      <div ref={ref} className={combinedClassName} {...restProps}>
        {children}
      </div>
    );
  },
);

CarouselHeader.displayName = 'CarouselHeader';
